module.exports = __webpack_public_path__ + "images/emoji/cool.8ac64bc70c34789ea9d6.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/cool.png
// module id = Nv0F
// module chunks = 13